<template lang="pug">
.method__container.row-container
  .col-container
    h1.method__title
      | Наша
      br
      | Методология
    p.method__subtitle
      | Решения приносящие прибыль
      br
      | нашим клиентам

    .method__section
      .method__section-text
        h3.method__section-title Аудит
        p.method__section-subtitle
          | Перед тем, как что-то
          br
          | рекомендовать, мы тщательно
          br
          | изучаем проект, его слабые
          br
          | и сильные стороны.
          br
          | Предложенный нами план всегда
          br
          | опирается исключительно на факты
          br
          | и на потребности бизнеса клиента.
        .method__bridge
      picture
        source(type="image/webp" srcset="~assets/images/method/method_1.webp")
        img(src="~assets/images/method/method_1.jpg").method__section-img
    .method__section
      .method__section-text
        h3.method__section-title Изучение проблем клиента
        p.method__section-subtitle
          | Тщательное изучение узких мест
          br
          | сайта клиента и тех бизнес
          br
          | процессов, которые выстроены
          br
          | вокруг сайта.
        .method__bridge
      picture
        source(type="image/webp" srcset="~assets/images/method/method_2.webp")
        img(src="~assets/images/method/method_2.jpg").method__section-img
    .method__section
      .method__section-text
        h3.method__section-title
          | Составление плана
          br
          | развития проекта в целом
        p.method__section-subtitle
          | В отличие от классических
          br
          | веб-студий, мы не ограничиваемся
          br
          | рекомендациями только по сайту
          br
          | клиента, а предлагаем
          br
          | комплексный план по устранению
          br
          | проблем в тех сферах бизнеса
          br
          | клиента, которые напрямую
          br
          | взаимодействуют с его сайтом.
        .method__bridge
      picture
        source(type="image/webp" srcset="~assets/images/method/method_3.webp")
        img(src="~assets/images/method/method_3.jpg").method__section-img
    .method__section
      .method__section-text
        h3.method__section-title
          | Разработка
          br
          | эргономичного интерфейса
        p.method__section-subtitle
          | От того насколько интерфейс удобен
          br
          | пользователю, зависит его лояльность
          br
          | и конверсия посетителей в клиенты.
          br
          | Мы не побоимся поставить знак равенства
          br
          | между: конверсия сайта == доходность бизнеса.
          br
          br
          | Современные версии поисковых роботов
          br
          | Яндекс и Google тщательно отслеживают
          br
          | поведенческие факторы. Иначе говоря,
          br
          | насколько сайт "человекоудобен".
          br
          | Без учтенных в дизайне пользовательских
          br
          | факторов грамотное и успешное продвижение

          br
          | в SEO невозможно.
        .method__bridge
      picture
        source(type="image/webp" srcset="~assets/images/method/method_4.webp")
        img(src="~assets/images/method/method_4.jpg").method__section-img
    .method__section
      .method__section-text
        h3.method__section-title
          | Разработка сайта
        p.method__section-subtitle
          | Командой программистов
          br
          | верстается сайт и пишется
          br
          | технический функционал проекта
          br
          | с нуля или на основе движков.
          br
          br
          | Мы работаем со следующими
          br
          | движками, фреймворками: Django,
          br
          | Bootstrap, Backbone и т.д.
        .method__bridge
      picture
        source(type="image/webp" srcset="~assets/images/method/method_5.webp")
        img(src="~assets/images/method/method_5.jpg").method__section-img
    .method__section.method__section_last
      .method__section-text
        h3.method__section-title
          | Сдача проекта клиенту
        p.method__section-subtitle
          | Подавляющая часть наших
          br
          | клиентов, получая готовый проект
          br
          | и решенные задачи в своем
          br
          | бизнесе, остаются
          br
          | с нами навсегда. Также они
          br
          | доверяют нам свою рекламу
          br
          | в интернете.
      picture
        source(type="image/webp" srcset="~assets/images/method/method_6.webp")
        img(src="~assets/images/method/method_6.jpg").method__section-img
    BaseFooter(:formValue="footer_data")
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useMethodologyStore } from '~/stores/methodology'

const methodologyStore = useMethodologyStore()
await methodologyStore.setMethodPage()
const { title, footer_data, meta, og } = storeToRefs(methodologyStore)

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>

<style lang="scss" scoped>
.method {

  &__container {
    --block-height: 564px;
    --indent: 60px;
    --indent-left: 110px;
    --line-width: 2px;
    --line-height: 112px;

    @media (min-width: 1024px) and (max-width: 1279px) {
      padding-left: 5vw;
      padding-right: 5vw;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__title {
    color: $primary;
    margin-bottom: 10px;
    font-size: 34px;

    @include l-desktop {
      margin-bottom: 5px;
    }
  }

  &__subtitle {
    color: $primary;
    margin-bottom: 60px;

    @media (min-width: $breakpoint-medium) {
      margin-bottom: 145px;
    }
  }

  &__section {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;

    @media (min-width: $breakpoint-large) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__section:not(.method__section_last) {
    @media (min-width: $breakpoint-desktop) {
      min-height: var(--block-height);
    }
  }

  &__section+.method__section {
    margin-top: 115px;

    @media (min-width: $breakpoint-large) {
      margin-top: 200px;
    }

    @media (min-width: $breakpoint-notebook) {
      margin-top: var(--indent);
    }
  }

  &__section-img {
    width: 100%;
    height: 165px;
    margin-bottom: 40px;
    object-fit: cover;
    object-position: 50% 50%;

    @media (min-width: $breakpoint-small) {
      height: 300px;
    }

    @media (min-width: $breakpoint-large) {
      width: auto;
      height: auto;
      margin-bottom: 0;
      margin-left: 20px;
      height: 345px;
      width: 689px;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      height: auto;
      width: 489px;
    }
  }

  &__section-text {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  &__section-title {
    color: $dark;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  &__section-subtitle {
    color: $dark;
    line-height: 1.4;
    position: relative;

    @media (min-width: $breakpoint-notebook) {
      margin-bottom: 0;
    }
  }

  &__bridge {
    --circle-color: var(--main-color);

    display: none;
    position: relative;
    margin-left: var(--indent-left);
    border-left: var(--line-width) solid $primary;
    min-height: var(--line-height);

    @media (min-width: $breakpoint-notebook) {
      display: block;
      flex: 2;
      margin-top: var(--indent);
    }

    @include end-circle-vertical;
  }
}
</style>
